import { Component } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { close, closeOutline } from 'ionicons/icons';
import { LoginFormComponent } from '../login-form/login-form.component';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonToolbar,
    IonIcon,
    IonTitle,
    TranslateModule,
    IonButtons,
    IonButton,
    LoginFormComponent,
  ],
})
export class LoginModalComponent {
  constructor(private modalController: ModalController) {
    addIcons({ closeOutline, close });
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
